import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

import InputField from '../../../../components/inputs/inputField';
import SelectField from '../../../../components/inputs/selectField';
import FilesUploaderModal from "../../../../components/files/filesUploaderModal";
import FileUploadInputBox from "../../../../components/inputs/fileUploadInputBox";

class AddTeamModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            teamName: '',
            selectedGroup: '',
            teamIcon: '',
            requiredFields:{
                teamName: false,
                selectedGroup: false,
                teamIcon: false
            }
        };
    }

    addTeam = async () => {
        const { orgId, eventId, toggle } = this.props;
        const { teamName, teamIcon, selectedGroup } = this.state;

        const requiredFields = this.state.requiredFields;

		let valid = true;
		
        if (teamName === '') {
            valid = false;
            requiredFields.teamName = true;
        }else{
            requiredFields.teamName = false;
        }
        if (selectedGroup === '') {
            valid = false;
            requiredFields.selectedGroup = true;
        }else{
            requiredFields.selectedGroup = false;
        }
        if (teamIcon === '') {
            valid = false;
            requiredFields.teamIcon = true;
        }else{
            requiredFields.teamIcon = false;
        }


        if(valid){
            this.setState({ submitting: true, invalid: false });
            await API().post(`Organizations/${orgId}/events/${eventId}/engagementteams`,
                {
                    name: teamName,
                    group: selectedGroup,
                    icon: teamIcon,
                }).then((res) => {
                    if (res.data) {
    
                        this.props.addNewTeam(res.data, () => {
                            toggle();
                        });
    
    
                    }
                }).catch((err) => {
                    console.log(err);
                    this.setState({ submitting: false });
                })
        }else{
            this.setState({ requiredFields });
        }

       

        
    };

    render() {
        const { isOpen, toggle, event } = this.props;
        const {
            submitting,
            teamIcon,
            teamName,
            selectedGroup,
            requiredFields
        } = this.state;


        return (
            <div>
                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Add Team"}
                    bodyHeaderText={'Designate a group as a team to enable team-based activities'}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Team Name"
                                    value={teamName}
                                    onChange={(e) => this.setState({ teamName: e.target.value })}
                                    required={true}
                                    errorTrigger={requiredFields.teamName}
                                />

                                <SelectField
                                    label={'Group'}
                                    classes="w-100"
                                    options={event.groups.map(group => {
                                        return { label: group.name, value: group._id }
                                    })
                                    }
                                    value={
                                        selectedGroup && event.groups.find(group => group._id === selectedGroup) ? (
                                            {
                                                label: event.groups.find(group => group._id === selectedGroup).name,
                                                value: selectedGroup
                                            }
                                        ) : (
                                            {
                                                label: '',
                                                value: ''
                                            }
                                        )
                                    }
                                    required={true}
                                    errorTrigger={requiredFields.selectedGroup}
                                    onChange={(path) => {
                                        this.setState({
                                            selectedGroup: path.value
                                        });
                                    }}
                                />

                                <FileUploadInputBox
                                    label="Upload Team Icon"
                                    onClick={() => {
                                        this.setState({
                                            uploadingTeamIcon: true,
                                        });
                                    }}
                                    value={teamIcon}
                                    required={true}
                                    clearFile={() => {
                                        this.setState({
                                            teamIcon: ''
                                        });
                                    }}
                                    addText="Image"
                                    errorTrigger={requiredFields.teamIcon}
                                />

                                {this.state.uploadingTeamIcon && <FilesUploaderModal
                                    title="Image"
                                    isOpen={this.state.uploadingTeamIcon}
                                    toggle={() => {
                                        this.setState({
                                            uploadingTeamIcon: false,
                                        });
                                    }}
                                    eventId={this.props.eventId}
                                    links={{
                                        getAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
                                        addAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
                                    }}
                                    orgId={this.props.orgId}
                                    addFiles={(fileURL) => {
                                        this.setState({
                                            uploadingTeamIcon: false,
                                            teamIcon: fileURL
                                        });

                                    }}
                                />}

                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Add Team' : 'Adding...'}
                    actionButton={() => this.addTeam()}
                    actionButtonDisabled={submitting}
                ></FieldModal>
            </div>

        );
    }
}

export default AddTeamModal;
